import NotFound from './notFoundPage'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
  const { common: { currentSite } } = state

  return {
    currentSite
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const NotFoundContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotFound)

export default NotFoundContainer



// WEBPACK FOOTER //
// ./client/pages/notFoundContainer.js